<template>
  <div class="date-converter">
    <h2>Date to Milliseconds Converter</h2>
    <form @submit.prevent="convertDateToMilliseconds">
      <div>
        <label for="dateInput">Enter Date:</label>
        <input v-model="dateInput" type="datetime-local" id="dateInput" required />
      </div>
      <button type="submit">Convert</button>
    </form>

    <div v-if="milliseconds !== null">
      <h3>Milliseconds:</h3>
      <p>{{ milliseconds }}</p>
      <button @click="copyToClipboard">Copy</button>

      <!-- Display the success message -->
      <div v-if="copyMessage" class="success-message">{{ copyMessage }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dateInput: "", // User input for date
      milliseconds: null, // The result in milliseconds
      copyMessage: "", // To show the success message
    };
  },
  methods: {
    convertDateToMilliseconds() {
      // Convert the input date to a Date object
      const date = new Date(this.dateInput);

      // Get the milliseconds from the Date object
      this.milliseconds = date.getTime();
      this.copyMessage = ""; // Reset the message when a new date is entered
    },
    copyToClipboard() {
      // Create a temporary input element to copy the milliseconds value
      const tempInput = document.createElement('input');
      tempInput.value = this.milliseconds;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);

      // Show a success message
      this.copyMessage = "Milliseconds copied to clipboard!";
    },
  },
};
</script>

<style scoped>
.date-converter {
  text-align: center;
  margin-top: 50px;
}

form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

label {
  font-weight: bold;
}

input {
  padding: 5px;
  margin: 5px;
  width: 200px;
}

button {
  padding: 10px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;
}

button:hover {
  background-color: #45a049;
}

h3 {
  margin-top: 20px;
}

.success-message {
  margin-top: 10px;
  color: green;
  font-weight: bold;
}
</style>
